// extracted by mini-css-extract-plugin
export default {"container":"_1QAIY","content":"_2XJM1","section":"_2drqz","sectionTitle":"N7oGe","sectionDescription":"_2XoPn","separator":"_1iM9_"};